import { isPrivateView } from '@/common/components/FilterViews/helpers'
import {
  getFixedGroupIds,
  getInitialSelectedGroupIds,
  haveSameGroupIds,
} from '@/common/components/FilterViews/ManageVisibilityDrawer/ManageVisibilityForm/helpers'
import { viewVisibilities } from '@/common/components/FilterViews/ViewVisibilityFields/constants'
import useViewVisibility from '@/common/components/FilterViews/ViewVisibilityFields/hooks/useViewVisibility/useViewVisibility'

const useManageVisibilityForm = ({ view, groups, ownGroupIds, canSelectGroups, onSave }) => {
  const fixedGroupIds = getFixedGroupIds(ownGroupIds, view)
  const viewVisibility = useViewVisibility({
    initialVisibility: isPrivateView(view) ? viewVisibilities.private : viewVisibilities.shared,
    initialSelectedGroupIds: getInitialSelectedGroupIds(view, fixedGroupIds),
    groups,
    fixedGroupIds,
    canSelectGroups,
  })

  const hasChanges = !haveSameGroupIds(viewVisibility.sharedWithGroups, view.shared_with_groups)

  const handleSave = () => onSave(viewVisibility.sharedWithGroups)

  return {
    ...viewVisibility,
    fixedGroupIds,
    isFormValid: viewVisibility.isVisibilityValid,
    hasChanges,
    handleSave,
  }
}

export default useManageVisibilityForm
